module.exports = __webpack_public_path__ + "img/trash-2.5dda1f39.svg";